import type { SettingsEntityKey } from '../model/settings.types';

export const SETTINGS_TOAST_MESSAGES = {
  addSuccess: 'Novo item adicionado com sucesso.',
  addError: 'Erro ao adicionar novo item. Tente novamente',
  editSuccess: 'Edição salva com sucesso.',
  editError: 'Erro ao salvar edição. Tente novamente',
  deleteSuccess: 'Item deletado com sucesso.',
  deleteError: 'Erro ao deletar item. Tente novamente',
  searchError: 'Erro ao realizar a busca. Tente novamente',
  duplicateError: 'Ops! Parece que já existe um item com esse nome. Altere e salve novamente.',
} as const;

export const SETTINGS_DELETE_TITLES: Record<SettingsEntityKey, string> = {
  indexing: 'Tem certeza que deseja deletar o Indexador?',
  recordOrigin: 'Tem certeza que deseja deletar a Origem do registro?',
  recordType: 'Tem certeza que deseja deletar o Tipo do registro?',
  protectionMeans: 'Tem certeza que deseja deletar o Meio de Proteção?',
  recordStage: 'Tem certeza que deseja deletar a Etapa do Registro?',
};

export const SETTINGS_DELETE_DESCRIPTION = 'A ação não pode ser desfeita';
